<template>
    <div class="addressedit">
        <div class="edit WhiteBg">
            <div class="celllist flex-row">
                <div class="label">收货人</div>
                <input class="content" :disabled="true" v-model="name" placeholder="请输入收货人姓名" placeholder-class="placeholder" />
            </div>
            <div class="celllist flex flex-y-center">
                <div class="label">手机号码</div>
                <input class="content" v-model="phone" type="number" placeholder="请填写收货人手机号码" placeholder-class="placeholder" />
            </div>
            <div class="celllist flex flex-y-center" @click="showAddressClick">
                <div class="label">所在地区</div>
                <div class="content">{{ region.length ? region[0] + region[1] + region[2] : '' }}</div>
                <van-icon name="arrow" size="32px" color="#CCCCCC" />

            </div>
            <div class="celllist flex ">
                <div class="label">详细地址</div>
                <textarea disable-default-padding v-model="street" class="street" placeholder="街道、楼牌号等" placeholder-class="placeholder" />
            </div>
        </div>
        <div class="setcheck flex  flex-y-center">
            <span class="Black font28 padding-right-xs">设为默认地址</span>
            <van-checkbox v-model="checked" checked-color="#333F48" shape="square">
            </van-checkbox>
        </div>
        <div class="fixed flex-row flex-between flex-y-center">
            <button v-show="$route.query.type !== 'add'" class="import" @click="delAddress">删除</button>
            <div></div>
            <button class="del White" @click="saveAddress">保存</button>
        </div>
        <van-popup v-model="showAddress" position="bottom">
            <van-area :value="regionCode" title="标题" :area-list="areaList" @confirm="areaConfirm" @cancel="areaCancel" />
        </van-popup>
    </div>
</template>
<script>
    import { Toast, Dialog } from 'vant'
    import areaList from '@/assets/areaList'
    import request from "@/utils/request";

    export default {
        name: "addressEditJm",
        data() {
            return {
                name: '',
                checked: false,
                phone: '',
                street: '',
                areaList, // 地区数据
                showAddress: false, // 是否显示地址选择器
                region: [], // 选中的地区 省、市、区
                regionCode: '', // 默认选中的地区编码
            };
        },
        created() {
            this.name = this.$store.state.user.name
            if (this.$route.query.type == "add") {
                document.title = '新建收货地址'
            } else {
                document.title = '编辑收货地址'
                const query = this.$route.query
                this.id = query.id
                const address = JSON.parse(query.address)
                const selectedRegion = Object.entries(areaList.county_list).find(item => item[1] === address.district)
                this.regionCode = selectedRegion ? selectedRegion[0] : ''
                this.phone = address.phone
                this.street = address.street
                this.region = [address.province, address.city, address.district]
                this.checked = Number(query.isDefault)
            }
        },
        methods: {
            showAddressClick() {
                this.showAddress = true
            },
            areaConfirm(eventDetail) {
                const [province, city, district] = eventDetail
                this.showAddress = false
                this.region = [province.name, city.name, district.name]
                this.regionCode = district.code
            },
            areaCancel() {
                this.showAddress = false
            },
            // 保存
            saveAddress() {
                if (!this.phone) {
                    Toast({ position: 'top', message: '请输入收货人手机号码' })
                    return;
                } else if (this.phone.length != 11) {
                    Toast({ position: 'top', message: '请输入11位正确的手机号码' })
                    return;
                }
                if (this.region.length == 0) {
                    Toast({ position: 'top', message: '请选择所在地区' })
                    return;
                }
                if (!this.street) {
                    Toast({ position: 'top', message: '请输入详细地址' })
                    return;
                }
                const [province, city, district] = this.region;
                let address = {
                    sex: 0,
                    name: this.name,
                    phone: this.phone,
                    province,
                    city,
                    district,
                    street: this.street,
                };
                let params = {
                    address: JSON.stringify(address),
                    isDefault: this.checked ? 1 : 0,
                };
                if (this.id) {
                    params.id = this.id;
                    this.editRecAddress(params);
                } else {
                    this.addRecAddress(params);
                }
            },
            // 删除地址
            delAddress() {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '确定要删除此收货地址吗？',
                    confirmButtonColor: '#3fb8e2'
                })
                    .then(() => {
                        request({
                            url: "/jm/address/deleteRecAddress?id=" + this.id,
                            method: "get",
                        })
                            .then(() => {
                                this.$router.go(-1)
                            }).catch((error) => {
                                Toast({ position: 'top', message: error ?? '' })
                            })
                    })
                    .catch(() => {
                    })
            },
            // 新增
            addRecAddress(params) {
                request({
                    url: "/jm/address/addRecAddress",
                    method: "post",
                    data: params
                })
                    .then(() => {
                        this.$router.go(-1)
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 修改
            editRecAddress(params) {
                request({
                    url: "/jm/address/editRecAddress",
                    method: "post",
                    data: params
                })
                    .then(() => {
                        this.$router.go(-1)
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            }
        },
    };
</script>
<style lang="less" scoped>
    .addressedit {
        height: 100%;
        overflow-y: auto;
        background: #f5f6f5;
    }

    .Grey2 {
        color: #666666;
    }

    .placeholder {
        font-size: 28px;
        color: #999999;
    }

    .addressedit {
        padding: 30px;
    }

    .addressedit .edit {
        border-radius: 12px;
    }

    .addressedit .edit .celllist {
        border-bottom: 2px solid rgba(215, 215, 215, 0.3);
        padding: 20px 30px;
        min-height: 80px;
    }

    input:disabled {
        background: #fff;
    }

    .celllist .label {
        width: 160px;
        line-height: 40px;
        height: 40px;
        font-size: 28px;
    }

    .celllist .content {
        flex: 1;
        line-height: 40px;
        height: 40px;
        font-size: 28px;
        border: none;
    }

    .celllist .street {
        flex: 1;
        font-size: 28px;
        line-height: 40px;
        height: 140px;
    }

    textarea {
        border: none;
    }

    .celllist .content,
    .celllist .street {
        color: #666666;
    }

    /* 设为默认地址 */
    .setcheck {
        height: 40px;
        width: 100%;
        justify-content: flex-end;
        margin-top: 40px;
    }

    .van-checkbox__icon {
        font-size: 32px !important;
    }

    .padding-right-xs {
        padding-right: 20px;
    }

    /* 底部按钮 */
    .fixed {
        width: 690px;
        height: 180px;
        position: fixed;
        bottom: 0;
        z-index: 20;
    }

    .fixed button {
        width: 310px !important;
        height: 88px;
        border-radius: 50px;
        line-height: 55px;
        text-align: center;
        font-size: 32px;
        margin: 0;
    }

    .fixed .import {
        color: #333f48;
        border: 2px solid #333f48;
        background: #ffffff;
    }

    .fixed .del {
        color: #ffffff;
        border: 2px solid #333f48;
        background: #333f48;
    }

    :deep(.van-checkbox) {
        margin-bottom: 0 !important;
    }
</style>